import React, { useEffect } from 'react'
import { trackStartVideo, trackStartRewatchVideo } from '../../analytics'
import useLocale from '../../hooks/useLocale'
import classNames from 'classnames'

const sources = {
  de: require('media/lifesum-intro-de.mp4'),
  da: require('media/lifesum-intro-dk.mp4'),
  en: require('media/lifesum-intro-en.mp4'),
  fr: require('media/lifesum-intro-fr.mp4'),
  no: require('media/lifesum-intro-no.mp4'),
  ru: require('media/lifesum-intro-ru.mp4'),
  sv: require('media/lifesum-intro-se.mp4'),
}

const Video = () => {
  const image = React.useRef()
  const videoRef = React.useRef()
  const { language } = useLocale()
  const [started, setStarted] = React.useState(false)
  const [stopped, setStopped] = React.useState(false)
  const [chromeLoaded, setChromeLoaded] = React.useState(false)
  const source = sources[language] || sources.en

  useEffect(() => {
    setChromeLoaded(image.current.complete)
  }, [image.current])

  const stopVideo = () => {
    const video = videoRef.current
    if (video.currentTime >= 26.25) {
      video.currentTime = 26.45
      video.pause()
      setStopped(true)
    }
  }

  const togglePlayback = () => {
    const video = videoRef.current

    if (video.currentTime < 26.45) {
      if (video.paused) {
        video.play()
      } else {
        video.pause()
      }
    }
  }

  const replay = () => {
    const video = videoRef.current
    video.currentTime = 0
    video.play()
    setStopped(false)
    trackStartRewatchVideo()
  }

  const play = () => {
    const video = videoRef.current
    video.play()
    setStarted(true)
    trackStartVideo()
  }

  const handleImageLoaded = () => {
    setChromeLoaded(true)
  }

  return (
    <div
      className={classNames('c-hero__phone transition', {
        'opacity-0': !chromeLoaded,
      })}
    >
      <picture>
        <source
          type="image/webp"
          srcSet={`${require('media/phone.webp')}, ${require('media/phone@2x.webp')} 2x`}
        />
        <source
          srcSet={`${require('media/phone.png')}, ${require('media/phone@2x.png')} 2x`}
        />
        <img
          ref={image}
          onLoad={handleImageLoaded}
          src={require('media/phone.png')}
          alt=""
        />
      </picture>
      <video
        onClick={togglePlayback}
        onTimeUpdate={stopVideo}
        className="c-hero__phone-video"
        playsInline
        muted
        ref={videoRef}
        poster={require('media/features/calorie-counter/1.jpg')}
      >
        <source src={source} />
      </video>
      <div
        className={classNames(
          'c-hero__phone-replay',
          stopped && 'c-hero__phone-replay--show'
        )}
      >
        {stopped && (
          <button className="c-hero__phone-replay-button" onClick={replay}>
            <span>Replay</span>
          </button>
        )}
      </div>
      <div
        className={classNames(
          'c-hero__phone-play',
          !started && 'c-hero__phone-play--show'
        )}
      >
        {!started && (
          <button className="c-hero__phone-play-button" onClick={play}>
            <span>Play</span>
          </button>
        )}
      </div>
    </div>
  )
}

export default Video
